import axios from 'axios';
import API from '../config/API';

// Roles & permissions — thin client for /api/v2/permissions/* (beu-node-v2
// docs/permissions.md §4). Same envelope handling as sites.service: v2 reports
// refusals as HTTP 200 { statusCode: 0, error }, so reject those.
function headers() {
    return { 'Content-Type': 'application/json', accessToken: localStorage.getItem('accessToken') || '' };
}
const url = (path) => API.PERMISSIONS + path;
const data = (p) => p.then((r) => {
    const payload = r && r.data;
    if (!payload) return payload;
    if (payload.statusCode === 0 && payload.error) {
        const msg = (payload.error && (payload.error.responseMessage || payload.error.message)) || 'Request failed';
        const err = new Error(msg);
        err.response = { data: { ...payload, message: msg } };
        throw err;
    }
    if (payload.responseData !== undefined) return payload.responseData;
    if (payload.data !== undefined) return payload.data;
    return payload;
});

export const permissionsService = {
    me: () => data(axios.get(url('me'), { headers: headers() })),
    roles: () => data(axios.get(url('roles'), { headers: headers() })),
    createRole: (body) => data(axios.post(url('roles'), body, { headers: headers() })),
    updateRole: (key, body) => data(axios.put(url(`roles/${encodeURIComponent(key)}`), body, { headers: headers() })),
    resetRole: (key) => data(axios.post(url(`roles/${encodeURIComponent(key)}/reset`), {}, { headers: headers() })),
    deleteRole: (key) => data(axios.delete(url(`roles/${encodeURIComponent(key)}`), { headers: headers() })),
    people: () => data(axios.get(url('people'), { headers: headers() })),
    setAssignment: (userId, body) => data(axios.put(url(`people/${encodeURIComponent(userId)}`), body, { headers: headers() })),
    removeElsewhere: (userId) => data(axios.delete(url(`people/${encodeURIComponent(userId)}/elsewhere`), { headers: headers() })),
};

export default permissionsService;
